import './App.css';
import {TailSpin} from "react-loader-spinner";
import {AlertsManager, Box, Button, createAlertsManager, Flex, GlobalStyles, H1, Text} from '@bigcommerce/big-design';
import {useEffect, useState} from "react";
import ConfigurePrimaryProductModal from "./components/ConfigurePrimaryProductModal";
import LinkVariableProductModal from "./components/LinkVariableProductModal";
import SettingsModal from "./components/SettingsModal";
import {getProducts} from "./api/products";
import {getClient} from "./api/clients";

export const alertsManager = createAlertsManager();

function App(props) {
    const STATUS_TEXT_COLLECTION = [
        'Great business needs Great patience!',
        'It\'s a wonderful day :)',
        'Keep waiting there..',
        'We value your patience',
        'Almost there. Excellence takes a moment.',
        'Smart choices take time',
        'Success is loading.. just like your next big order',
        'Just a few seconds more..',
        'Almost there..'
    ];

    const [loading, setLoading] = useState(false);
    const [appStatus, setAppStatus] = useState('Loading');
    const [appStatusText, setAppStatusText] = useState('');
    const clientID = props.storeHash; // Fetch StoreHash from the store
    const [isOpenConfigPrimaryProduct, setIsOpenConfigPrimaryProduct] = useState(false);
    const [isOpenLinkVariableProduct, setIsOpenLinkVariableProduct] = useState(false);
    const [isOpenSettings, setIsOpenSettings] = useState(false);
    // Fetch primary products from the database and store
    const [primaryProductData, setPrimaryProductData] = useState([]);
    const [items, setItems] = useState(primaryProductData);
    // Fetch store settings from the database and store
    const [storeSettings, setStoreSettings] = useState({});

    // Reset loading texts when loading status is changed
    useEffect(() => {
        setAppStatus('Loading');
        setAppStatusText('');
    }, [loading]);

    const setStatus = (status, statusText) => {
        if (status)
            setAppStatus(status);
        if (statusText)
            setAppStatusText(statusText);
        else {
            const randNum = (Math.random() * 10) % STATUS_TEXT_COLLECTION.length;
            const newStatusText = STATUS_TEXT_COLLECTION[randNum];
            setAppStatusText(newStatusText);
        }
    }

    // Fetch primary products from the database and store
    const loadPrimaryProducts = async () => {
        const products = await getProducts(clientID);
        if (!products || products.length === 0) {
            setPrimaryProductData([]);
            setItems([]);
            return;
        }

        const tempProducts = [];
        for (const product of products) {
            // Get name and image url using product id from store
            /*const result = await getProductByID(product.id);
            if (!result.success) {
                showErrorMessage('Error', 'Unable to read product details from your BigCommerce store.');
                break;
            }
            const productDetails = result.product;
            // Ignore products in database that do not exist in the store
            if (result.success && !productDetails) {
                // Delete the product from database
                removeProduct(clientID, product.id).then();
                continue;
            }
            if (productDetails && productDetails.name !== product.name) {
                // Update new product name in database
                updateProductName(clientID, product.id, productDetails.name);
            }*/
            tempProducts.push({
                id: product.id,
                name: product.name,
                categories: [], // load value later
                combinations: product.combinations,
                variations: product.combinations ? product.combinations.length : 0,
                stock: 0, // load value later
                thumbnail_image_url: '', // load value later
                tiny_image_url: '' // load value later
            });
        }
        setPrimaryProductData(tempProducts);
        setItems(tempProducts);
    }
    // Fetch store settings from the database and store
    const loadStoreSettings = async () => {
        // Load store settings
        const clientData = await getClient(clientID);
        setStoreSettings(clientData);
    }

    const openConfigPrimaryProducts = () => {
        setLoading(true);
        loadPrimaryProducts().then(() => setIsOpenConfigPrimaryProduct(true)).finally(() => setLoading(false));
    }
    const openLinkVariableProducts = () => {
        setLoading(true);
        loadPrimaryProducts().then(() => setIsOpenLinkVariableProduct(true)).finally(() => setLoading(false));
    }
    const openSettings = () => {
        setLoading(true);
        loadStoreSettings().then(() => setIsOpenSettings(true)).finally(() => setLoading(false));
    }

    return (
        <>
            <div className="App">
                <GlobalStyles/>
                <AlertsManager manager={alertsManager}/>

                <header className="App-header">
                    <H1 color="secondary10">Smart Variations</H1>
                    <br/>
                    <Flex justifyContent="space-around">
                        <Box backgroundColor="secondary10" padding="large" paddingHorizontal="xxxLarge"
                             shadow="floating">
                            {props.authorized ?
                            <div className="main-menu" style={{marginLeft: '10px', marginRight: '10px'}}>
                                <Button marginVertical="small" mobileWidth="auto"
                                        onClick={() => openConfigPrimaryProducts()}>
                                    Configure Primary Products
                                </Button>
                                <br/>
                                <Button marginVertical="small" mobileWidth="auto"
                                        onClick={() => openLinkVariableProducts()}>
                                    Link Variable Products
                                </Button>
                                <br/>
                                {/*<Button marginVertical="small" mobileWidth="auto" variant="secondary">
                                    Get Storefront Features
                                </Button>
                                <br/>*/}
                                <Button marginVertical="small" mobileWidth="auto" variant="secondary"
                                        actionType="destructive" onClick={() => openSettings()}>
                                    Settings
                                </Button>
                            </div>
                            :
                            <div className="main-menu" style={{marginLeft: '10px', marginRight: '10px'}}>
                                <Text color='danger'>{props.error}</Text>
                            </div>
                            }
                        </Box>
                    </Flex>

                    {loading ?
                    <div style={{
                        position: "absolute",
                        width: "100%",
                        height: "100%",
                        opacity: 0.9,
                        zIndex: 10000,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: "black"
                    }}>
                        <TailSpin color="white" radius="2px" strokeWidth="3px" wrapperStyle={{alignSelf: "center"}}/>
                        <div style={{display: "flex", flexDirection: "column", marginLeft: "25px", justifyContent: "center", alignItems: "start"}} >
                            <p color="secondary10" style={{fontSize: "1.8rem", fontWeight: 400, lineHeight: "3rem", margin: 0}}>{appStatus}</p>
                            <p color="secondary20" style={{fontSize: "1rem", fontWeight: 200, lineHeight: "1rem", margin: 0}}>{appStatusText}</p>
                        </div>
                    </div>
                    : <></>}
                </header>

                <ConfigurePrimaryProductModal isOpen={isOpenConfigPrimaryProduct}
                                              setIsOpen={setIsOpenConfigPrimaryProduct} clientID={clientID}
                                              primaryProductData={primaryProductData} items={items}
                                              setItems={setItems} setLoading={setLoading} setStatus={setStatus}/>
                <LinkVariableProductModal isOpen={isOpenLinkVariableProduct} setIsOpen={setIsOpenLinkVariableProduct}
                                          clientID={clientID} primaryProductData={primaryProductData} items={items}
                                          setItems={setItems} setLoading={setLoading} setStatus={setStatus}/>
                <SettingsModal isOpen={isOpenSettings} setIsOpen={setIsOpenSettings}
                               clientID={clientID} storeSettings={storeSettings} setStoreSettings={setStoreSettings}
                               setLoading={setLoading} setStatus={setStatus}/>
            </div>
        </>
    );
}

export default App;
